import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useModal } from "tir-pm-toolkit";
import {
  TirPmModal,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import { TaskParameterModel } from "@/components";
import { ref } from "vue";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'parameter-remove-modal',
  props: {
  /**Имя области */
  namespaceName: { type: String },
},
  emits: ["remove"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


/**События */


/**Управление окном */
const { visible, open, close } = useModal();
/**Заголовок окна */
const title = ref("");
/**Удаляемый параметр */
const removing = ref<TaskParameterModel>();

/**Открытие окна */
const openModal = (_removing: TaskParameterModel, _basic: TaskParameterModel) => {
  if (!_removing || !_basic) return;

  removing.value = _removing;

  title.value = `Атрибут "${_removing.Name}" во всех тикетах рабочей области "${props.namespaceName}" будет заменен на "${_basic.Name}`;
  open();
};
/**Подтверждение удаления */
const confirmRemove = () => {
  emit("remove", removing.value?.Name);
  close();
};

/**Код для использования по ref */
__expose({ open: openModal });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    classes: "parameter-remove-modal",
    isCloseOverlay: true,
    isWithBack: false,
    title: title.value,
    "is-visible": _unref(visible),
    onClose: _unref(close)
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        onClick: confirmRemove
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Продолжить ")
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
        onClick: _unref(close)
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отменить ")
        ]),
        _: 1
      }, 8, ["size", "variant", "onClick"])
    ]),
    _: 1
  }, 8, ["title", "is-visible", "onClose"]))
}
}

})